import React, { useEffect, useState } from 'react';
import Select from 'react-select';

export default function LineOfBusinessToggle({ router, currentUser }) {
    const [lineOfBusiness, setLineOfBusiness] = useState(
        sessionStorage.getItem("lineOfBusiness") || ""
    );
    const [options, setOptions] = useState([]);
 
    const handleLineOfBusinessChange = (e) => {
        if (e) {
            localStorage.setItem("prevlineOfBusiness",lineOfBusiness);
            setLineOfBusiness(e.value);
            localStorage.setItem("lineOfBusiness", e.value);
            sessionStorage.setItem("lineOfBusiness", e.value);
            window.location.reload();
        }
    };
 
    useEffect(() => {
        // Use user details from sessionStorage 
        const user = JSON.parse(sessionStorage.getItem("FrUser") || "{}");
        const storedLob = sessionStorage.getItem("lineOfBusiness");
 
        if (!user || !user.clientLobRoles) return;
 
        const clientNames = Object.keys(user.clientLobRoles);
        if (clientNames.length === 0) return;
 
        const firstClient = clientNames[0];
        const lobKeys = Object.keys(user.clientLobRoles[firstClient]);
 
        const optionsArray = lobKeys.map((lob) => {
            const normalized = lob.toLowerCase() === "aca" ? "Commercial" : lob;
            return { value: normalized, label: normalized };
        });
 
        setOptions(optionsArray);
 
        let finalLob = storedLob;
 
        if (!storedLob) {
            const defaultLob =
                optionsArray.find((x) => x.value.toLowerCase() === "ma") ||
                optionsArray[0];
 
            finalLob = defaultLob?.value || "";
            localStorage.setItem("lineOfBusiness", finalLob);
            sessionStorage.setItem("lineOfBusiness", finalLob)
        } else {
            const exists = optionsArray.some((opt) => opt.value === storedLob);
            if (!exists) {
                finalLob = optionsArray[0]?.value || "";
                localStorage.setItem("lineOfBusiness", finalLob);
                sessionStorage.setItem("lineOfBusiness", finalLob)
            }
        }
 
        setLineOfBusiness(finalLob);
    }, [currentUser]);
 
    return (
        currentUser ?
            <div className="nav-line-of-business-container">
                <Select value={lineOfBusiness} onChange={handleLineOfBusinessChange}
                    options={options} />
            </div> : null
    )

   
}